import React, { forwardRef } from 'react';

import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBriefcase, faUser } from '@fortawesome/pro-solid-svg-icons';

import type { Contact } from 'bundles/backoffice/contacts/types';

interface Props {
  className?: string;
  contact: Contact;
  size?: 'xl';
}

export default forwardRef<HTMLSpanElement, Props>(function ContactIcon({ className, contact, size }, ref) {
  return (
    <span className={classNames('avatar', size && `avatar-${size}`, className)} ref={ref}>
      <span className="avatar-fallback">
        {contact.initials || <FontAwesomeIcon icon={contact.isBusiness ? faBriefcase : faUser} />}
      </span>
    </span>
  );
});
